export default "__VITE_ASSET__CeW7tb5D__"